import script from "./DiagnosticsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticsCard.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticsCard.vue?vue&type=style&index=0&id=317f7631&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317f7631"]])

export default __exports__